import React, { useEffect, useState } from "react";
import { Col, Image, Row } from "react-bootstrap";
import CreatableSelect from "react-select/creatable";
import { components } from "react-select";
import moment from "moment";
import Collapse from "../../../animation/collapse";
import { Checkbox, InputWithIcon } from "src/components/input";
import SwitchButton from "src/components/switchButton";
import { Link, UpdateLinkRequest } from "src/types/link";
import { NDA } from "src/types/nda";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Truncate from "src/components/truncate";
import CopyLink from "../copyLink";
import { updateLink } from "src/redux/actions/link";
import { useDispatch } from "react-redux";
import Reveal from "src/components/animation";
import Button from "src/components/button";
import TimePicker from "src/components/timePicker";
import DatePickerComponent from "src/components/datePicker";

import cx from "classnames";
import _ from "lodash";
import styles from "./options.module.scss";
import userRoleService from "src/services/userRoles.service";
import Tooltip from "src/components/tooltip";

const noNDA = '/images/no_template.svg';
interface OptionsProps {
  link: Link;
  openLinkPanel?: boolean;
  setOpenLinkPanel?: (value: boolean) => void;
  setLinkUpdated?: (value: boolean) => void;
  onClose?: () => void;
  className?: string;
}

const Options: React.FC<OptionsProps> = ({
  link,
  openLinkPanel,
  setLinkUpdated,
  onClose,
  setOpenLinkPanel,
  className,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const linkObject = useSelector((state: any) => _.get(state, "link", {}));
  const shareSettings = useSelector((state: any) => _.get(state, "accounts.item.shareSettings", {}));
  const ndaTemplates = useSelector((state: any) => _.get(state, "nda.items", {}));
  const updations = _.get(linkObject.updation, link.id, false);
  const domains = _.get(link, "domains", []);
  const [allowEmailDomain, setAllowEmailDomain] = useState<boolean>(
    domains?.some((domain: any) => domain.allow),
  );
  const [localLink, setLocalLink] = useState<Link>(link);
  const [isExpiryEnabled, setExpiryEnabled] = useState<boolean>(
    localLink.expiryDate ? true : false,
  );
  const [showNda, setShowNda] = useState<boolean>(localLink.nda ? true : false);
  const [expiryDate, setExpiryDate] = useState<any>(localLink.expiryDate);
  const [time, setTime] = useState<any>(localLink.expiryDate);
  const [toggleDomains, setToggleDomains] = useState<boolean>(
    _.size(localLink.domains) > 0,
  );
  const [password, setPassword] = useState<string>(
    localLink.hasPassword ? "*******" : "",
  );
  const [inputType, setInputType] = useState<string>("password");
  const [showUpdatedLink, setShowUpdatedLink] = useState(false);
  const [isPasswordChanged, setIsPasswordChanged] = useState(
    !localLink.hasPassword,
  );
  const [selectInput, setSelectInput] = useState("");
  const [isAdditionalUTMparamsSet, setIsAdditionalUTMparamsSet] =
    useState<boolean>(
      !!_.get(localLink.utmCampaign, "source") ||
        !!_.get(localLink.utmCampaign, "medium") ||
        !!_.get(localLink.utmCampaign, "term") ||
        !!_.get(localLink.utmCampaign, "content"),
    );
  const [errors, setErrors] = useState<any>({});
  useEffect(() => {
    if (updations.updated) {
      if (!onClose) {
        setShowUpdatedLink(true);
      } else {
        onClose();
      }
    }
  }, [updations]);

  useEffect(() => {
    if (showUpdatedLink) {
      setShowUpdatedLink(false);
      if (setLinkUpdated) {
        setLinkUpdated(false);
      }
    }
    showSaveButton();
  }, [localLink]);
  const getStyles = () => {
    return {
      placeholder: (base: any) => ({
        ...base,
        fontSize: "0.75rem",
      }),
      control: (base: any, state: any) => ({
        ...base,
        background: "#fff",
        border: "1px solid #dbdbdb",
        borderRadius: "0.625rem",
        fontSize: "0.875rem",
        color: "#000",
        fontWeight: "500",
        boxShadow: state.isFocused ? 0 : base.boxShadow,
        "&:hover": {
          border: state.isFocused ? "1px solid #dbdbdb" : base.border,
          boxShadow: state.isFocused ? 0 : base.boxShadow,
        },
      }),
      multiValue: (base: any) => ({
        ...base,
        padding: "2px 8px",
        fontSize: "0.875rem !important",
        color: "#000",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "1rem",
        borderRadius: "1.25rem",
        background: "#dbdbdb66",
        marginRight: "4px",
        "&:hover": {
          background: "#dbdbdb",
        },
      }),
      multiValueRemove: (base: any) => ({
        ...base,
        color: "#000",
        padding: "0px 5px",
        cursor: "pointer",
        fontSize: "1em",
        lineHeight: "1em",
        "&:hover": {
          background: "#dbdbdb",
        },
      }),
      indicatorsContainer: (base: any) => ({
        ...base,
        display: "none",
      }),
      indicatorSeparator: (base: any) => ({
        ...base,
        alignSelf: "auto",
      }),
      dropdownIndicator: (base: any, state: any) => ({
        ...base,
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
        color: " var(--primarySubTextColor)",
        "&:hover": {
          color: " var(--primarySubTextColor)",
        },
        svg: {
          height: "16px",
          width: "16px",
        },
      }),
    };
  };

  const handleCheckChange = (key: string) => {
    setErrors({});
    if (key === "gated") {
      if (localLink.gated) {
        setLocalLink((prev) => {
          return {
            ...prev,
            gated: false,
            validateEmailDomain: false,
            validateEmailOtp: false,
            domains: [],
          };
        });
        setToggleDomains(false);
        setAllowEmailDomain(false);
      } else {
        setLocalLink((prev) => {
          return {
            ...prev,
            gated: true,
            validateEmailDomain: _.get(shareSettings, "validateEmailDomain", false),
            validateEmailOtp: _.get(shareSettings, "validateEmailOtp", false),
          }
        });
      }
    } else if (key === "allowEmailDomain") {
      setToggleDomains(!toggleDomains);
      setLocalLink((prev) => {
        return {
          ...prev,
          domains: [],
        };
      });

      setAllowEmailDomain(!allowEmailDomain);
      showSaveButton();
    } else if (key === "expiryDateChange") {
      setExpiryEnabled(!isExpiryEnabled);
      setLocalLink((prev) => {
        return {
          ...prev,
          expiryDate: null,
        };
      });
    } else if (key === "ndaChange") {
      setShowNda(!showNda);
      setLocalLink((prev) => {
        return {
          ...prev,
          nda: null,
        };
      });
    } else if (key === "utmParams") {
      setIsAdditionalUTMparamsSet(!isAdditionalUTMparamsSet);
    } else {
      setLocalLink((prev) => {
        return {
          ...prev,
          [key]: !prev[key],
        };
      });
    }
  };
  const handleSelectChange = (option: any) => {
    const newDomains = option
      ? option.map((item: any) => ({ allow: true, name: item.value }))
      : [];

    setLocalLink((prev) => ({
      ...prev,
      domains: newDomains,
    }));
    showSaveButton();
  };
  const handleChangeExpiryDate = (date: any) => {
    const selectedDate = moment(date).format("DD MMM YYYY");
    setExpiryDate(selectedDate);
    if (!time) {
      setTime(selectedDate);
    }
    if (setLinkUpdated) {
      setLinkUpdated(true);
    }
    setLocalLink((prev) => {
      return {
        ...prev,
        isExpiryToggled: true,
      };
    });
  };
  const showSaveButton = () => {
    if (!_.isEqual(localLink, link) && setLinkUpdated) {
      setLinkUpdated(true);
    }
  };
  const handleTimeChange = (time: any) => {
    setTime(time);
    if (!expiryDate) {
      setExpiryDate(new Date());
    }
    if (setLinkUpdated) {
      setLinkUpdated(true);
    }
    setLocalLink((prev) => {
      return {
        ...prev,
        isExpiryToggled: true,
      };
    });
  };

  const calculateNewExpiryDate = () => {
    if (!expiryDate || !time) return "";
    const formattedDate = moment(expiryDate).format("YYYY-MM-DD");
    const formattedTime = moment(time).format("HH:mm:ss");

    const dateTimeString = `${formattedDate}T${formattedTime}`;

    const dateObj = new Date(dateTimeString);

    if (isNaN(dateObj.getTime())) {
      return "";
    }

    // ISO string
    return dateObj.toISOString();
  };
  const toggleInput = () => {
    if (!isPasswordChanged) {
      setPassword("");
    } else {
      setInputType(inputType === "text" ? "password" : "text");
    }
  };
  const handleSave = () => {
    const faultedDomains: any[] = [];
    const expiry = calculateNewExpiryDate();
    if (localLink.gated && !_.isEmpty(localLink.domains)) {
      const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      localLink.domains.forEach((domain) => {
        if (!domainRegex.test(domain.name)) {
          faultedDomains.push(domain);
        }
      });
    }
    if (faultedDomains.length > 0 || (allowEmailDomain && _.size(localLink.domains) === 0)) {
      setErrors({
        ...errors,
        domains: "Please enter a valid domain",
      });
      return;
    } else if (localLink.hasPassword && !password) {
      setErrors({ password: "Enter a valid password" });
      return;
    } else if (isExpiryEnabled && !expiryDate) {
      setErrors({ expiryDate: "Please select a valid date" });
    } else if (isExpiryEnabled && moment(expiry).isBefore(moment())) {
      setErrors({
        expiryDate: "Expiry date should be greater than current date",
      });
    } else if (showNda && !localLink.nda && _.size(ndaTemplates) !== 0) {
      setErrors({ nda: "Select an NDA template" });
    } else {
      if (_.size(ndaTemplates) === 0) {
        setShowNda(false);
      }
      setErrors({});
      let saveLinkRequest: UpdateLinkRequest = {
        id: localLink.id,
        request: {
          canDownload: localLink.canDownload,
          canReshare: localLink.canReshare,
          engage: localLink.engage,
          downloadEditable: localLink.downloadEditable,
          gated: localLink.gated,
          validateEmailDomain: localLink.validateEmailDomain,
          validateEmailOtp: localLink.validateEmailOtp,
          domains: localLink.domains,
          nda: localLink.nda ? localLink.nda.id : null,
          expiryDate: isExpiryEnabled ? calculateNewExpiryDate() : null,
        },
      };
      if (_.get(localLink, "utmCampaign.name") || isAdditionalUTMparamsSet) {
        saveLinkRequest = {
          ...saveLinkRequest,
          request: {
            ...saveLinkRequest.request,
            utmCampaign: localLink.utmCampaign,
          },
        };
      }
      if (localLink.hasPassword && isPasswordChanged) {
        saveLinkRequest = {
          ...saveLinkRequest,
          request: {
            ...saveLinkRequest.request,
            password: password,
          },
        };
      }
      if (!localLink.hasPassword) {
        saveLinkRequest = {
          ...saveLinkRequest,
          request: {
            ...saveLinkRequest.request,
            password: null,
          },
        };
      }

      dispatch(updateLink(saveLinkRequest));
    }
  };
  const handleReset = () => {
    setLocalLink(link);
    setExpiryEnabled(!!link.expiryDate);
    setShowNda(!!link.nda);
    setExpiryDate(link.expiryDate);
    setTime(link.expiryDate);
    setPassword(link.hasPassword ? "*******" : "");
    setIsPasswordChanged(!link.hasPassword);
    setToggleDomains(_.size(link.domains) > 0);
    setAllowEmailDomain(domains?.some((domain: any) => domain.allow));
    setErrors({});

    setIsAdditionalUTMparamsSet(
      !!_.get(link.utmCampaign, "source") ||
        !!_.get(link.utmCampaign, "medium") ||
        !!_.get(link.utmCampaign, "term") ||
        !!_.get(link.utmCampaign, "content"),
    );
    if (setLinkUpdated && setOpenLinkPanel) {
      setLinkUpdated(false);
      setOpenLinkPanel(true);
    }
  };
  const handleDomainSelect = (event: any, eventType = "keyDown") => {
    if (event.target.value === "") {
      return;
    }
    const value = {
      name: event.target.value,
      allow: true,
    };
    if (event.key === "Enter" || event.key === "Tab" || eventType === "blur") {
      if (!localLink.domains.includes(value)) {
        setLocalLink((prev) => {
          return {
            ...prev,
            domains: [...prev.domains, value],
          };
        });
        setSelectInput("");
      }
    }
  };
  const renderInputIcon = () => {
    if (password) {
      if (!isPasswordChanged) {
        return "paperflite-edit";
      } else {
        if (inputType !== "password") {
          return "paperflite-eye";
        } else {
          return "paperflite-hidden-eye";
        }
      }
    }
  };

  const handleUTMParamsChange = (key: string, value: string) => {
    const trimmedValue = value && value.trim();
    if(value === ""){
      setLocalLink((prev) => {
        return {
          ...prev,
          utmCampaign: {
            ...prev.utmCampaign,
            [key]: "",
          },
        };
      });
    }
    if (trimmedValue) {
      setLocalLink((prev) => {
        return {
          ...prev,
          utmCampaign: {
            ...prev.utmCampaign,
            [key]: trimmedValue,
          },
        };
      });
    }
  };
  return (
    <>
      <div className={cx(styles.container, className)}>
        {localLink.type === "campaign" && (
          <Row className={cx(styles.settingsRow)}>
            <Col className={styles.settingRowTitle} sm={10} xs={10} xl={10}>
              Add additional UTM paramters
            </Col>
            <Col className={styles.settingsToggle} sm={2} xs={2} xl={2}>
              <SwitchButton
                id="utmparamaters"
                className={styles.switch}
                checked={isAdditionalUTMparamsSet}
                handleCheck={() => handleCheckChange("utmParams")}
              />
            </Col>

            <Collapse
              isOpen={isAdditionalUTMparamsSet}
              customStyles={{ padding: 0 }}
            >
              <Row className={styles.optionsContainer}>
                <Col xl={12} className={styles.optionsRow}>
                  <InputWithIcon
                    value={_.get(localLink.utmCampaign, "source", "") || ""}
                    placeholder="Enter campaign source"
                    onChange={(e) => {
                      handleUTMParamsChange("source", e.target.value);
                    }}
                  />
                </Col>
                <Col xl={12} className={styles.optionsRow}>
                  <InputWithIcon
                    value={_.get(localLink.utmCampaign, "medium") || ""}
                    placeholder="Enter campaign medium"
                    onChange={(e) => {
                      handleUTMParamsChange("medium", e.target.value);
                    }}
                  />
                </Col>
                <Col xl={12} className={styles.optionsRow}>
                  <InputWithIcon
                    value={_.get(localLink.utmCampaign, "term") || ""}
                    placeholder="Enter campaign term"
                    onChange={(e) => {
                      handleUTMParamsChange("term", e.target.value);
                    }}
                  />
                </Col>
                <Col xl={12} className={styles.optionsRow}>
                  <InputWithIcon
                    value={_.get(localLink.utmCampaign, "content") || ""}
                    placeholder="Enter campaign content"
                    onChange={(e) => {
                      handleUTMParamsChange("content", e.target.value);
                    }}
                  />
                </Col>
              </Row>
            </Collapse>
          </Row>
        )}

        <Row className={cx(styles.settingsRow)}>
          <Col className={styles.settingRowTitle} sm={10} xs={10} xl={10}>
            Allow recipients to download
          </Col>
          <Col className={styles.settingsToggle} sm={2} xs={2} xl={2}>
            <SwitchButton
              id="canDownload"
              className={styles.switch}
              checked={_.get(localLink, "canDownload", false)}
              handleCheck={() => handleCheckChange("canDownload")}
            />
          </Col>

          <Collapse
            isOpen={_.get(localLink, "canDownload", false)}
            customStyles={{ padding: 0 }}
          >
            <Row className={styles.optionsContainer}>
              <Col xl={12} className={styles.optionsRow}>
                <Checkbox
                  label="Editable"
                  checked={_.get(localLink, "downloadEditable", false)}
                  className={styles.check}
                  type="radio"
                  onChange={() => handleCheckChange("downloadEditable")}
                />
              </Col>
              <Col xl={12} className={styles.optionsRow}>
                <Checkbox
                  label="Read only"
                  type="radio"
                  className={styles.check}
                  checked={!localLink.downloadEditable}
                  onChange={() => handleCheckChange("downloadEditable")}
                />
              </Col>
              <Col xl={12} className={styles.optionsRow}>
                <span className={styles.disclaimer}>
                  *This applies to PPTs, Docs, Google Slides and Google Docs.
                </span>
              </Col>
            </Row>
          </Collapse>
        </Row>

        <Row className={cx(styles.settingsRow)}>
          <Col className={styles.settingRowTitle} sm={10} xs={10} xl={10}>
            Allow recipients to reshare
          </Col>
          <Col className={styles.settingsToggle} sm={2} xs={2} xl={2}>
            <SwitchButton
              id="canReshare"
              className={styles.switch}
              checked={_.get(localLink, "canReshare", false)}
              handleCheck={() => handleCheckChange("canReshare")}
            />
          </Col>
        </Row>

        {link.type !== "personalised" && (
          <>
            <Row className={cx(styles.settingsRow)}>
              <Col className={styles.settingRowTitle} sm={10} xs={10} xl={10}>
                Enable email gating
              </Col>
              <Col className={styles.settingsToggle} sm={2} xs={2} xl={2}>
                <SwitchButton
                  id="gated"
                  className={styles.switch}
                  checked={_.get(localLink, "gated", false)}
                  handleCheck={() => handleCheckChange("gated")}
                />
              </Col>

              <Collapse
                isOpen={_.get(localLink, "gated", false)}
                customStyles={{ padding: 0 }}
              >
                <Row className={styles.optionsContainer}>
                  <Col xl={12} className={styles.optionsRow}>
                    <Checkbox
                      label="Validate with OTP"
                      className={styles.check}
                      checked={_.get(localLink, "validateEmailOtp", false)}
                      onChange={() => handleCheckChange("validateEmailOtp")}
                    />
                  </Col>
                  <Col xl={12} className={styles.optionsRow}>
                    <Checkbox
                      label="Validate work email"
                      className={styles.check}
                      checked={_.get(localLink, "validateEmailDomain", false)}
                      onChange={() => handleCheckChange("validateEmailDomain")}
                    />
                  </Col>
                  <Col xl={12} className={styles.optionsRow}>
                    <Checkbox
                      label="Validate users from selected domains"
                      className={styles.check}
                      checked={allowEmailDomain}
                      onChange={() => handleCheckChange("allowEmailDomain")}
                    />
                  </Col>
                  <Col xl={12} className={styles.optionsRow}>
                    <Collapse
                      isOpen={toggleDomains}
                      customStyles={{ height: "auto" }}
                    >
                      <CreatableSelect
                        components={{
                          MultiValueRemove: CustomMultiValueRemove,
                        }}
                        value={
                          localLink.domains &&
                          localLink.domains.map((val) => ({
                            value: val.name,
                            label: val.name,
                          }))
                        }
                        defaultMenuIsOpen={false}
                        onChange={(newValue) => handleSelectChange(newValue)}
                        styles={getStyles()}
                        isMulti
                        isClearable
                        inputValue={selectInput}
                        onInputChange={(inputValue) => {
                          setSelectInput(inputValue);
                        }}
                        menuIsOpen={false}
                        backspaceRemovesValue
                        onKeyDown={(e) => handleDomainSelect(e)}
                        onBlur={(e) => {
                          handleDomainSelect(e, "blur");
                        }}
                      />
                      {errors.domains && <ErrorLabel error={errors.domains} />}
                    </Collapse>
                  </Col>
                </Row>
              </Collapse>
            </Row>
          </>
        )}
        {userRoleService.canAccessEngage() && !userRoleService.isEngageViewOnly() && (
          <Row className={cx(styles.settingsRow)}>
            <Col className={styles.settingRowTitle} xs={10} xm={10} xl={10}>
              Enable engage
            </Col>
            <Col className={styles.settingsToggle} xs={2} sm={2} xl={2}>
              <SwitchButton
                id="engage"
                className={styles.switch}
                checked={_.get(localLink, "engage", false)}
                handleCheck={() => handleCheckChange("engage")}
              />
            </Col>
          </Row>
        )}

        <Row className={cx(styles.settingsRow)}>
          <Col className={styles.settingRowTitle} xs={10} xm={10} xl={10}>
            Set a password
          </Col>
          <Col className={styles.settingsToggle} xs={2} xm={2} xl={2}>
            <SwitchButton
              id="password"
              className={styles.switch}
              checked={_.get(localLink, "hasPassword", false)}
              handleCheck={() => handleCheckChange("hasPassword")}
            />
          </Col>
          <Collapse
            isOpen={_.get(localLink, "hasPassword", false)}
            customStyles={{ padding: 0 }}
          >
            <Row>
              <Col xl={12}>
                <InputWithIcon
                  value={password}
                  placeholder="Enter password"
                  type={inputType}
                  onChange={(e) => {
                    setIsPasswordChanged(true);
                    setPassword(e.target.value);
                    setLocalLink((prev) => {
                      return {
                        ...prev,
                        password: e.target.value,
                      };
                    });
                  }}
                  onIconClick={toggleInput}
                  className={styles.passwordInput}
                  icon={renderInputIcon()}
                />
              </Col>
              {errors.password && <ErrorLabel error={errors.password} />}
            </Row>
          </Collapse>
        </Row>

        <Row className={cx(styles.settingsRow)}>
          <Col className={styles.settingRowTitle} xs={10} xm={10} xl={10}>
            Set an expiry date and time
          </Col>
          <Col className={styles.settingsToggle} xs={2} xm={2} xl={2}>
            <SwitchButton
              id="expiryDate"
              className={styles.switch}
              checked={isExpiryEnabled}
              handleCheck={() => handleCheckChange("expiryDateChange")}
            />
          </Col>

          <Collapse isOpen={isExpiryEnabled} customStyles={{ padding: 0 }}>
            <Row className={styles.datePickerContainer}>
              <Col xl={6} sm={6} xs={6}>
                <DatePickerComponent
                  value={expiryDate && moment(expiryDate).format("DD MMM YYYY")}
                  handleDateChange={handleChangeExpiryDate}
                  minDate={moment().startOf("day").toDate()}
                  customInput={<InputWithIcon icon="paperflite-calendar" />}
                  className={styles.datePicker}
                />
              </Col>
              <Col xl={6} sm={6} xs={6}>
                <TimePicker
                  value={time ? moment(time).format("hh:mm A") : "pick a time"}
                  onChange={handleTimeChange}
                />
              </Col>
              {errors.expiryDate && <ErrorLabel error={errors.expiryDate} />}
            </Row>
          </Collapse>
        </Row>

        <Row className={cx(styles.settingsRow, styles.ndaRow)}>
          <Col className={styles.settingRowTitle} xs={10} xm={10} xl={10}>
            Enable NDA
          </Col>
          <Col className={styles.settingsToggle} xs={2} xm={2} xl={2}>
            <SwitchButton
              id="nda"
              className={styles.switch}
              checked={showNda}
              handleCheck={() => handleCheckChange("ndaChange")}
            />
          </Col>

          <Collapse isOpen={showNda} customStyles={{ padding: 0 }}>
            <Row className={styles.optionsContainer}>
              {errors.nda && <ErrorLabel error={errors.nda} />}

              <Col xl={12} className={styles.ndaContainer}>
                {_.size(ndaTemplates) === 0 && (
                  <Row>
                    <Col xl={12} className={styles.emptyMessage}>
                      <Image src={noNDA} width={150} height={150} />
                      <span className={styles.title}>
                        Type less, Share more
                      </span>
                      <span className={styles.subTitle}>
                        Create reusable NDA templates for you and your teams.
                      </span>
                      <Button
                        variant="primary"
                        icon="paperflite-add"
                        text="Create New"
                        className={styles.createNDA}
                        onClick={() => navigate("/settings/nda-templates/new")}
                      />
                    </Col>
                  </Row>
                )}
                {_.size(ndaTemplates) !== 0 &&
                  ndaTemplates.map((nda: NDA) => (
                    <>
                      <Tooltip placement="auto" content={_.size(nda.name) > 50 ? nda.name || undefined : ""}>
                        <Row key={nda.id} className={styles.optionsRow}>
                          <Checkbox
                            label={nda.name || ""}
                            className={styles.check}
                            type="radio"
                            checked={localLink?.nda?.id === nda.id}
                            onChange={() =>
                              setLocalLink((prev) => {
                                showSaveButton();
                                return {
                                  ...prev,
                                  nda: nda,
                                };
                              })
                            }
                          />
                        </Row>
                      </Tooltip>
                    </>
                  ))}
              </Col>
            </Row>
          </Collapse>
        </Row>
      </div>

      <Reveal show={showUpdatedLink}>
        <div className={styles.updatedLinkPanel}>
          <Row>
            <Col xl={12} className={styles.updatedLinkTitle}>
              Updated Link
            </Col>
          </Row>
          <Row>
            <Col xs={11} xm={11} xl={11}>
              <Truncate>
                <span className={styles.link}>{localLink.url}</span>
              </Truncate>
            </Col>
            <Col xs={1} xm={1} xl={1} className={styles.updatedLink}>
              <CopyLink link={localLink} />
            </Col>
          </Row>
        </div>
      </Reveal>
      <div
        className={cx(styles.actions, {
          [styles.hideActions]: showUpdatedLink,
        })}
      >
        {!showUpdatedLink && (
          <Reveal show={!openLinkPanel}>
            <div className={styles.buttonContainer}>
              <Button
                variant="primary"
                text={updations.updating ? "Saving..." : "Save"}
                onClick={handleSave}
                icon="paperflite-tick"
                className={styles.saveButton}
                disabled={_.isEqual(localLink, link) || updations.updating}
              />

              {onClose && (
                <Button variant="secondary" text="Cancel" onClick={onClose} />
              )}
              {!onClose && (
                <Button
                  variant="secondary"
                  text="Reset"
                  onClick={handleReset}
                  disabled={updations.updating}
                />
              )}
            </div>
          </Reveal>
        )}
      </div>
    </>
  );
};

export default Options;

const ErrorLabel: React.FC<{ error: string }> = ({ error }) => {
  const errorRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (errorRef.current) {
      errorRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [error]);
  return (
    <Col xl={12} ref={errorRef} className={styles.errorLabel}>
      <i className="paperflite-danger"></i>
      <span>{error}</span>
    </Col>
  );
};

const CustomMultiValueRemove = (props) => {
  return (
    <components.MultiValueRemove {...props}>
      <i className={cx("paperflite-close", styles.selectCloseButton)}></i>
    </components.MultiValueRemove>
  );
};
